export { setFeatures } from "./actions";
import { SET_FEATURES } from "./constants";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FEATURES:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};
